import { Calculator, Info } from "lucide-react";

export const Header = () => (
  <header className="flex items-center gap-4 mb-6 pb-4 border-b border-slate-200 no-print" data-testid="app-header">
    <div className="w-12 h-12 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center shrink-0">
      <Calculator size={24} strokeWidth={2.2} />
    </div>
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 font-heading">
        Kalkulator napredovanja
      </h1>
      <p className="text-sm text-slate-500 mt-0.5">
        Izračun bodova i uvjeta za napredovanje učitelja, nastavnika, stručnih suradnika i ravnatelja
        (NN 68/2019 i 32/2021)
      </p>
      <p className="text-xs text-slate-500 mt-1">
        Unesite svoje podatke i broj aktivnosti, a bodovi se zbrajaju automatski. Kliknite ikonu{" "}
        <Info size={12} className="inline align-[-2px] text-blue-600" /> uz aktivnost za tumačenje
        MZOM-a i potrebne dokaze.
      </p>
    </div>
  </header>
);
